module.exports = __webpack_public_path__ + "static/media/51.64cc6628.png";